<div>
   
    <div class="my-4 row mx-0">
        <div class="col-lg-6 ps-md-2 px-0">
            <h5 class="text-start text-primary fw-bold ps-0 ms-0">Enter PAN Details</h5>
        </div>
        <div class="col-lg-6 text-end ps-md-2 px-0">
            <span class="badge rounded-pill text-bg-light text-success px-3 py-2">KRA Status : {{kraclient}}</span> 
            <span class="badge rounded-pill text-bg-light text-success mx-md-2 px-3 py-2">CKYC Status : {{ckycclient}} </span>
        </div>
        <div class="col-lg-12 ps-md-2 px-0">
            <p class="text-primary ">As per the recent guidelines, customer is required to provide details i.e. PAN, Name and Date of Birth as ITD (Income Tax Department).</p>
        </div>
    </div>
    <div class="mt-3 mb-4" *ngIf="panSiteName">
    </div>
    <div class="row mx-0 my-4">
    <div class="col-lg-6 pe-lg-5 ps-lg-2 px-0 my-3">
            <div>
                <nri-app-img-upld [imageName]="'PAN'" [disableFileUpload]="panvalidate" (getOcrDatas)="bindOcr($event)" (imageURL)="imageURL($event)"></nri-app-img-upld>
                <div class="text-danger small mb-4" *ngIf="panImgempty">
                    Please upload your pan card image
                </div>
            </div> 
        </div>
        <div  class="col-lg-6"></div>
        <div class="col-12 px-0" *ngIf="ocrSuccess">
            <form [formGroup]="registerForm" novalidate>
            <div class="row mx-0">
                <div class="col-lg-4 col-12">
                    <div class="form-floating ">
                        <input type="text" class="form-control text-uppercase" [ngClass]="registerForm.controls.CustomerName.value ? 'has-value' : ''" formControlName="CustomerName" name="name" autocomplete="off" id="name" placeholder="Enter name" (paste)="(false)" appAlphabetsOnly>
                        <label for="name">Name as per PAN card<span class="text-danger">*</span></label>
                        <div *ngIf="registerForm.controls.CustomerName.touched && registerForm.controls.CustomerName.errors" class="ms-3">
                            <span class="small text-danger">{{panNameMessage}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-12">
                    <div class="form-floating  position-relative">
                        <input type="text" class="form-control text-uppercase" [ngClass]="registerForm.controls.CustomerPan.value ? 'has-value' : ''" formControlName="CustomerPan" name="pan" autocomplete="off" maxlength="10" id="pan" placeholder="Enter PAN" (paste)="(false)" (input)="onPanChange($event);">
                        <label for="pan">PAN NO.<span class="text-danger">*</span></label>
                        <div *ngIf="registerForm.controls.CustomerPan.touched && registerForm.controls.CustomerPan.errors" class="ms-3">
                            <span class="small text-danger" *ngIf="registerForm.controls.CustomerPan.errors && !registerForm.controls.CustomerPan.errors['invalidPAN']">
                              {{panErrorMessage}}
                            </span>
                            <span class="small text-danger" *ngIf="registerForm.controls.CustomerPan.errors?.['invalidPAN']">
                              {{panValidMessage}}
                            </span>
                          </div>
                        <div class="nb-spinner" *ngIf="panLoader"></div>
                        <img src="./assets/images/green_check_icon.svg" class="pan-tick" *ngIf="panVerified">
                    </div>
                </div>
                <div class="col-lg-4 col-12">
                    <div class="input-group border form-floating rounded-2">
                        <input class="form-control mt-1 border-0 pe-0 ps-3 py-0" placeholder="DD/MM/YYYY" ngx-mydatepicker name="mydate" autocomplete="off"
                        formControlName="userDOB" id="dob" [readOnly]="(!panvalidate || ocrSuccess) ? true : false" required (input)="formatDateInput($event)" (keydown)="key($event)"   [options]="dobOptions" [defaultMonth]="defaultMonth" #dp="ngx-mydatepicker" (dateChanged)="onDateChanged($event);"/>
                        <label for="dob">Enter or Select DOB <span class="text-danger">*</span></label>
                        <span class="px-3 py-2">
                            <img src="./assets/images/Calendar.svg" (click)="(!panvalidate || ocrSuccess) ? '' : dp.toggleCalendar();">
                        </span>
                    </div>
                    <div class="text-danger small my-3" *ngIf="dobError">
                        Please provide your date of birth
                    </div>
                </div>
                <!-- <div class="col-lg-6 pe-lg-5 pe-md-2 mt-md-2">
            <div class="px-md-2 px-0 mb-5">
                <strong>Account Type <span class="text-danger">*</span></strong>
                <div class="mt-2 d-md-flex row row-cols-auto">
                    <div class="col">
                        <input class="ms-0 form-check-input" name="NRO" formControlName="NRO" type="radio" value="N" id="nri">
                        <label class="form-check-label ps-2" for="nri">NRI</label>
                    </div>
                    <div class="col">
                        <input class="ms-lg-3 form-check-input" name="NRO" formControlName="NRO" type="radio" value="Y" id="NRO">
                        <label class="form-check-label ps-2" for="NRO">NRO</label>
                    </div>
                </div>
            </div>
            </div> -->
            </div>
        </form>
        </div>
        
    </div>

    <div class="row my-2">
        <div class="col-12 col-lg-6">
            <div class="row">
                <div class="col-1">
                    <input class="ms-md-0 form-check-input" name="pep" type="checkbox" id="pep" [(ngModel)]="pep" (change)="pepChange(pep)" [ngModelOptions]="{standalone: true}">
                </div>
                <div class="col px-md-0">
                    <label class="form-check-label ps-1" for="pep">I am not politically-exposed (PEP) or related to a PEP</label>
                </div>
            </div>
        </div>
    </div>

    <div class="row mx-0 mt-5" *ngIf="!panvalidate" [@enterAnimation]>
        <div class="col-lg-6 pe-lg-5 ps-lg-2 px-0" *ngIf="selfieNeed">
            <nri-app-photo #photo (photoCheck)="getImageStatus($event)"></nri-app-photo>
        </div>
    </div>
    

    <div class="px-md-5 my-3 text-end">
        <button class="btn btn-primary px-4" [disabled]="panvalidate && registerForm.invalid" (click)="panvalidate && !panreject ? panValidation() : stageValidate()">{{panvalidate && !panreject ? 'Verify' : 'Next'}}</button>
    </div>
</div>

<div class="modal fade" id="panModal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header border-0 mb-0 pb-0 px-4">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="panResumeYes()"></button>
            </div>
            <div class="modal-body px-md-5 py-md-4 p-4">
                <div *ngIf="refExists">
                    <p class="normal">It looks like your PAN is already exists. Please Resume Journey.</p>
                    <p class="normal">
                        <button type="button" class="btn btn-primary  px-4 normal" data-bs-dismiss="modal" (click)="panResumeYes()">
                            Close
                        </button>
                        <!-- <button type="button" class="ms-md-4 ms-2 btn btn-primary  px-4 normal" data-bs-dismiss="modal">
                            No
                        </button> -->
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="appstatus" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">Welcome to SBI Securities</h1>
          <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
        </div>
        <div class="modal-body">
            Sorry, we cannot proceed with your NRI Demat account opening process. As a resident individual, you are not eligible to open an NRI account.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" (click)="reDirection()">Ok</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="TCSError" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header border-0 mb-0 pb-0 px-4">
                <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="panResumeYes()"></button> -->
            </div>
            <div class="modal-body px-md-5 py-md-4 p-4">
                <div>
                    <p class="normal">The PAN number entered is already Linked to an Existing Demat account with us. 
For further assistance, please reach out to our NRI Central Desk for Further process.</p>
<p class="normal">If you have any questions or need further assistance, feel free to contact our support team at NRIDESK.SSL@sbicapsec.com / +91 2268567464. </p>
                    <p class="normal">We are available from 9: 30 AM to 6:30 PM IST (Monday to Saturday only) except 2nd & 4th Saturdays.
We look forward to welcoming you to SBI Securities and providing you with a seamless trading and investing experience! </p>
                    <p class="normal">
                        <button type="button" class="btn btn-primary  px-4 normal" data-bs-dismiss="modal" (click)="reDirection()">
                            Close
                        </button>
                        <!-- <button type="button" class="ms-md-4 ms-2 btn btn-primary  px-4 normal" data-bs-dismiss="modal">
                            No
                        </button> -->
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>
<app-error-modal #errorComp></app-error-modal>
<nri-app-menu #menu class="d-none"></nri-app-menu>